<template>
  <footer id="footer" class="footer">
    <div class="container">

      <div class="footer__signoff">
        <p>Interested in working with us? <br>Let’s start something together.</p>
        <a class="enquire-btn" href="mailto:info@o-a.com.au?subject=Let’s start something together">Start a project</a>
     </div>

      <div class="footer__details">
        <div class="footer__column">
          <h4>Over and Above</h4>
          <p>Creative design <br>and development studio</p>
          <h4>Say Hello</h4>
          <p>+61 410 589 801 <br><a href="mailto:info@o-a.com.au">info@o-a.com.au</a></p>
        </div>
        <div class="footer__column">
          <h4>Office Location</h4>
          <p>Melbourne, Australia</p>
          <h4>Follow Us</h4>
          <p><a href="https://instagram.com/o_a_agency" target="_blank">Instagram</a>, <a href="https://twitter.com/o_a_agency" target="_blank">Twitter</a></p>
        </div>
      </div>

      <div class="footer__top" v-on:click="jumpToTop"><span></span><strong>OK, everybody. </strong>  Let's take it from the top</div>
      <div class="footer__copyright"><small>© Over and Above 2021</small></div>

    </div>
  </footer>
</template>

<script>

//import { ScrollTrigger } from "gsap/ScrollTrigger";


export default {
  name: 'Footer',

  props: {
    bodyScrollBar: null
  },

  methods: {

      jumpToTop: function(){
        let bodyScroll      = this.bodyScrollBar;
        bodyScroll.scrollTo(0, 0, 600);
      }
  }  
}
</script>
 
<style scoped>
 
</style>